<template>
  <v-dialog v-model="show" fullscreen>
    <v-container style="background-color: white">
      <v-row justify="space-around">
        <v-col cols="8">
          <v-layout>
            <v-img class="pt-0 pr-4" src="../../assets/checkmark.gif"> </v-img>
          </v-layout>
        </v-col>
      </v-row>

      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout class="font-weight-medium title">
            Abastecimento realizado com sucesso!
          </v-layout>
        </v-col>
      </v-row>

      <v-row justify="space-around">
        <v-col cols="11">
          <v-layout>
            <div class="font-weight-regular">
              Ficamos muito felizes que você tenha abastecido o veículo!
            </div>
          </v-layout>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div class="text-center w-100 mt-4 pb-16">
            <v-btn
              style="width: 95%"
              class="colorBtn "
              @click="$emit('voltar')"
            >
              <strong>VOLTAR</strong>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>
<script>
export default {
  props: { show: Boolean },
};
</script>

<style scoped>
.titulo {
  font-family: 'Sequel Sans';
  font-size: 20px;
  font-style: 'normal';
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: 'left';
}

.subtitulo {
  font-family: 'Sequel Sans';
  font-size: 14px;
  font-style: 'normal';
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: 'left';
}

.colorBtn {
  color: var(--primary-color) !important;
  background-color: var(--secondary-color) !important;
  text-decoration: none;
  text-transform: none;
}
</style>
